/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolEmojiFoodBeverageIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-emoji-food-beverage"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.5 21.8Q3.95 21.8 3.58 21.41Q3.2 21.02 3.2 20.48Q3.2 19.93 3.59 19.55Q3.98 19.18 4.53 19.18L19.5 19.18Q20.05 19.18 20.43 19.55Q20.8 19.93 20.8 20.48Q20.8 21.02 20.41 21.41Q20.02 21.8 19.48 21.8ZM18.68 7.8L20.18 7.8Q20.18 7.8 20.18 7.8Q20.18 7.8 20.18 7.8L20.18 4.8Q20.18 4.8 20.18 4.8Q20.18 4.8 20.18 4.8L18.68 4.8ZM7.83 17.68Q5.88 17.68 4.54 16.31Q3.2 14.95 3.2 13L3.2 5.13Q3.2 3.9 4.06 3.04Q4.92 2.17 6.15 2.17L9.05 2.17L9.05 5.8L7.03 7.4Q6.97 7.45 6.83 7.8L6.83 12.35Q6.83 12.57 6.99 12.74Q7.15 12.9 7.38 12.9L11.88 12.9Q12.1 12.9 12.26 12.74Q12.43 12.57 12.43 12.35L12.43 7.8Q12.43 7.75 12.22 7.4L10.25 5.8L10.25 2.17L20.18 2.17Q21.3 2.17 22.05 2.94Q22.8 3.7 22.8 4.8L22.8 7.8Q22.8 8.93 22.05 9.71Q21.3 10.5 20.18 10.5L18.68 10.5L18.68 13Q18.68 14.95 17.34 16.31Q16 17.68 14.05 17.68Z" fill={color} />
    </svg>
  );
}
